import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import product from "src/common/config/product";
import { buildPreviewUrl } from "../CreationForm/Adventurer/helpers";
import { getTrackingProps } from "../CreationForm/helpers";
import Adventurer from "../CreationForm/Adventurer";
import MultiAdventurerModal from "./MultiAdventurerModal";
import logger from "src/logger";
import "./ProductForm.scss";

const sizes = {
  "100%": "full-width",
  "80%": "guttered",
};

const submitMultiAdventurerForm =
  (props) => (formProps, resetForm, setFieldError) => {
    const characters = formProps.characters;
    if (characters.length >= formProps.minCharacterLimit) {
      const locale = props.form.localeOverride;

      const eagleProduct =
        props.model.eagleProduct ||
        props.model.eagleModel?.products?.find(
          ({ id }) => id === props.productId
        );
      const slug =
        eagleProduct?.slug || product.getProductBySku(props.productId).slug;

      if (!slug) {
        logger.error(
          "Failed to redirect user to canvas page as slug was missing"
        );
        setFieldError("base", props.getErrorMessage());
        return;
      }

      window.top.location.href = buildPreviewUrl(
        slug,
        { characters, locale },
        props.country
      );
    } else {
      resetForm();
    }
  };

const ProductForm = (props) => {
  const fields = props.form.body;
  const multiAdventurerField = fields.find(
    (field) => field.sliceType === "multi-adventurer"
  );
  const isMultiAdventurer = !!multiAdventurerField;
  const adventurerTrackingProps = getTrackingProps("adventurer");
  return (
    <section
      className={cx("product-form", {
        "product-form--multi-adventurer": isMultiAdventurer,
      })}
      id={props.id}
    >
      <div className="container-guttered">
        <div
          className={cx("product-form-wrapper", {
            [sizes[props.size]]: props.size,
          })}
        >
          {props.form.title && (
            <h3 className="product-form-title">{props.form.title}</h3>
          )}
          {isMultiAdventurer ? (
            <MultiAdventurerModal
              cancel={multiAdventurerField.primary.modalCancelLabel}
              productId={props.productId}
              form={props.form}
              media={props.media}
              isModalOpen={props.isMultiAdventurerOpen}
              onModalToggle={props.handleMultiAdventurerToggle}
              fetchPrismicProduct={props.fetchPrismicProduct}
              submitMultiAdventurerForm={submitMultiAdventurerForm(props)}
            />
          ) : (
            <Adventurer
              productId={props.productId}
              form={props.form}
              fetchPrismicProduct={props.fetchPrismicProduct}
              {...adventurerTrackingProps}
            />
          )}
        </div>
      </div>
    </section>
  );
};

ProductForm.propTypes = {
  productId: PropTypes.string.isRequired,
  form: PropTypes.shape({
    title: PropTypes.string,
    cta: PropTypes.string.isRequired,
    body: PropTypes.array.isRequired,
  }).isRequired,
  media: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  size: PropTypes.string,
  isMultiAdventurerOpen: PropTypes.bool.isRequired,
  fetchPrismicProduct: PropTypes.func.isRequired,
  handleMultiAdventurerToggle: PropTypes.func.isRequired,
};

export default ProductForm;
